import { Depth, InstallationSequence } from "../components/forge/panels/panelParameters";
import { IWallWindowCellSource } from "./wallFace";

export interface IPanelSource {
    id: string;
    wallFaceId: string;
    box: THREE.Box3;
    openings: IPanelSourceOpening[];
    louvres: IPanelSourceLouvre[];
    claddings: IPanelSourceCladdingCell[];
    origin: THREE.Vector3;
    offsetX: number;
    offsetY: number;
    thickness: number;
    userUniqueId: number;
    elementName: string;
    installationSequence: InstallationSequence;
    depth: Depth;
    panelTypeId: string;
    customPanelTypeId: string | null;
    isParapetPanel: boolean;
}

export interface IStudioPanelSource extends IPanelSource {
    /** Studio panel type, available only when calling from DS endpoint */
    panelType: IStudioPanelSourceType | null;
}

export interface IStudioPanelSourceType {
    id: string;
    status: PanelStatus;
}

export enum PanelStatus {
    Created = 1,

    GeneratedSuccessfully = 2,

    GenerationFailed = 3,
}

export interface IPanelSourceOpening {
    box: THREE.Box3;
    cells: IWallWindowCellSource[];
    insideColor: number;
    outsideColor: number;
    profileStyle: number;
    windowSillColor: number;
    /** Manufacturer's specification area in square feet */
    area: number;
    /** Weight in kilograms */
    weight: number;
}

export interface IPanelSourceLouvre {
    box: THREE.Box3;
    color: number;
    sillColor: number;
    sillDepth: number;
    rectangularCutouts: ILouvreCurtainRectangularCutout[];
    circularCutouts: ILouvreCurtainCircularCutout[];
}

export interface ILouvreCurtainRectangularCutout {
    box: THREE.Box3;
}

export interface ILouvreCurtainCircularCutout {
    center: THREE.Vector3;
    radius: number;
}

export interface IPanelSourceCladdingCell {
    box: THREE.Box3;
    color: string;
    rivetColor: string;
    depth: number;
    style: CladdingCellStyle;
    grainDirection: GrainDirection;
    thickness: number;
    topFlangeAngle: number;
}

export enum CladdingCellStyle {
    // @deprecated This value is not supported by the engine
    Concealed = 1,

    Exposed = 2,

    Acm = 3,
}

export enum GrainDirection {
    Vertical = 0,

    Horizontal = 1,
}